<template>
  
  <b-button variant="outline-dark" v-on:click="pressed">{{$t("ASSUME")}}</b-button>
  
  
</template>
<script>
import { ajaxGet } from "../../ajax";
import {apiUrl} from "@/main";

export default {
  props: ["TenantID", "token"],
  methods: {
    pressed: function(event) {
      event.preventDefault();

      ajaxGet(
        apiUrl() +"/tenants/" +
          parseInt(this.TenantID) + "/assume",
        this.assumeSuccess,
        this.dataError,
        this.token
      );
    },
    assumeSuccess: function(data) {
      //this.$emit("removeTenant", this.TenantID);

      var dta = {
        Token : data.Token,
        IsAdmin : true,
        IsTeacher : true
      };
    
      localStorage.token = data.Token;

        this.$bvToast.toast('Assumed into tenant ' + this.TenantID, { autoHideDelay: 5000, appendToast: true});

      this.$emit('setData', dta);
      var cmp = this;
      setTimeout(function() {
        cmp.$router.push('/students');
      }, 250);

    },
    dataError: function(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }
    }
  }
};
</script>